<template>
  <div class="pane-left" :style="{width:leftPaneWidth+'px'}">

    <div class="d-flex gap-4 pa-3">
      <v-switch v-model="localHorizontal"  hide-details
                label="horizontal layout"
                @update:modelValue="$emit('update:horizontal',localHorizontal)"/>
      <v-switch v-model="localCollapsable" hide-details
                label="foldable"
                @update:modelValue="$emit('update:collapsable',localCollapsable)"/>
    </div>

    <div class="tree-scroll-container">
      <vue3-tree-org
        :data="orgData"
        :horizontal="localHorizontal"
        :collapsable="localCollapsable"
        :label-style="{color:'#000',background:'#fff'}"
        :node-draggable="true"
        :scalable="true"
        :draggable="true"
        :default-expand-level="1"
        :define-menus="customMenus"
        @on-node-click="(evt, node) => $emit('nodeClick', evt, node)"
        @on-expand   ="(e,b,a)=>$emit('expandChange',e,b,a)"
        @on-contextmenu="e=>$emit('contextAction',e)"
        @on-node-drag-start="(e,n)=>$emit('dragStart',e,n)"
        @on-node-drag-end  ="(e,n)=>$emit('dragEnd',e,n)"
        @on-node-drag-over ="(e,n)=>$emit('dragOver',e,n)"
        @on-node-drag-leave="e=>$emit('dragLeave',e)"
      >
      <template #default="{node}">
        <div class="org-tree-node__text node-label custom-node"
            :class="[
              node.className,
              {
                dragging: draggedNodeId === node.id,
                'drop-target-highlight': highlightedNodeId === node.id
              }
            ]"
            @dragover.prevent
            @drop="e=>$emit('filterDrop',e,node)"
        >
          <div class="custom-content">{{ node.label||node.name }}</div>
          
          <div v-if="nodeDataSources(node).length"
              class="source-chips-row">
            <span v-for="src in nodeDataSources(node)" :key="src"
                  class="source-dot"
                  :style="{backgroundColor:sourceColors[src]||'#AAA'}"
                  :title="src"/>
          </div>
        </div>
      </template>
      </vue3-tree-org>
    </div>

    <div class="source-legend pa-2">
      <div v-for="(color,src) in sourceColors" :key="src"
           class="legend-item">
        <span class="legend-dot" :style="{backgroundColor:color}"></span>
        {{ src }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRefs, watch } from 'vue'
const props = defineProps({
  orgData:         Object,
  horizontal:      Boolean,
  collapsable:     Boolean,
  leftPaneWidth:   Number,
  draggedNodeId:   String,
  highlightedNodeId:String,
  sourceColors:    Object,
  nodeDataSources: Function,
  customMenus:     Array
})
const emit = defineEmits([
  'update:horizontal','update:collapsable',
  'nodeClick','contextAction','expandChange',
  'dragStart','dragEnd','dragOver','dragLeave',
  'filterDrop'
])

const {horizontal,collapsable} = toRefs(props)
const localHorizontal = ref(horizontal.value)
const localCollapsable= ref(collapsable.value)
watch(horizontal,   v=>localHorizontal.value=v)
watch(collapsable, v=>localCollapsable.value=v)

// The nodeStyle function has been removed as it is no longer needed.
</script>

<style scoped>
.pane-left{display:flex;flex-direction:column;background:#fafafa;min-height:0;overflow:hidden}
.tree-scroll-container{flex:1;min-height:0;overflow:auto;border:1px solid #ccc}
.source-legend{display:flex;flex-wrap:wrap;gap:1rem}
.legend-dot{width:12px;height:12px;border-radius:50%}

/* Base styles for all custom nodes */
.custom-node {
  border: 1px solid #ddd; /* Default border */
  color: #000; /* Default text color */
}

/* Style for nodes with attributes (Reverted to original solid blue) */
.custom-node.node-with-attributes {
  background-color: #108ffe;
  border-color: #108ffe;
  color: #fff;
}

/* Style for derived nodes (Updated to a consistent solid purple) */
.custom-node.node-derived {
  background-color: #6f42c1;
  border-color: #6f42c1;
  color: #fff;
}

.derived-banner {
  background-color: #6f42c1; /* Purple */
  color: white;
  padding: 3px 6px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  margin-bottom: 5px;
  display: inline-block;
}
</style>